import React from "react";
import classNames from "classnames";
import { ContentMediaPath } from "../utils/ContentMediaPath";
import { validateEmail } from "../utils/validation-func";
import Button from "../components/Button";
import { Link } from "../components/HomePage/models/HomePageModel";
import ImgLazyLoad from "./ImgLazyLoad";
import { SetLocalHasSubscribed } from "./WebStorage";

interface SubscribeNowPopupProps {
  backgroundColor?: string;
  backgroundImage?: string;
  content?: string;
  fontColor?: string;
  title?: string;
  isActive?: boolean;
  contentAlignment?: any;
  isBackgroundGradient?: boolean;
  popupCTA?: Link;
  deActivatePopup: () => void;
}

interface SubscribeNowPopupState {
  isPopupEmailValid: boolean;
  emailAddress: string;
}

class SubscribeNowPopup extends React.Component<
  SubscribeNowPopupProps,
  SubscribeNowPopupState
> {
  categories: string[] = [];

  constructor(props: SubscribeNowPopupProps) {
    super(props);

    this.state = {
      isPopupEmailValid: true,
      emailAddress: window.sessionStorage.getItem("userEmail") || "",
    };
    this.hexToRGB.bind(this);
  }

  hexToRGB(hex: string, alpha: number) {
    if (!!hex) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }

  render() {
    const activeState = classNames({
      "subscribe-now-popup": true,
      active: this.props.isActive,
      inactive: !this.props.isActive,
    });
    const emailInputContainerState = classNames({
      signUp: true,
      fromClass: true,
      "popup-has-error": !this.state.isPopupEmailValid,
    });
    const emailInputState = classNames({
      "has-error": !this.state.isPopupEmailValid,
    });
    const errorMessageState = classNames({
      error_msg: !this.state.isPopupEmailValid,
      active: !this.state.isPopupEmailValid,
    });

    const trySubmit = (emailAddress: string, url: string) => {
      this.setState({ isPopupEmailValid: validateEmail(emailAddress) }, () => {
        if (this.state.isPopupEmailValid) {
          console.log(emailAddress);
          window.sessionStorage.setItem("userEmail", emailAddress);
          SetLocalHasSubscribed();
          window.location.href = url;
        }
      });
    };

    const emailInput = ({ target: { value } }) => {
      this.setState({
        isPopupEmailValid: validateEmail(value),
        emailAddress: value,
      });
    };

    let backgroundStyle = null;

    if (!!this.props.backgroundColor) {
      if (this.props.isBackgroundGradient) {
        backgroundStyle = {
          backgroundImage: `linear-gradient(to top, ${this.hexToRGB(
            this.props.backgroundColor,
            0
          )},${this.props.backgroundColor},${this.props.backgroundColor},${
            this.props.backgroundColor
          })`,
          color: this.props.fontColor,
        };
      } else {
        backgroundStyle = {
          backgroundColor: this.props.backgroundColor,
          color: this.props.fontColor,
        };
      }
    } else {
      backgroundStyle = {
        backgroundImage:
          "linear-gradient(to top, rgba(255,255,255,0),white,white,white)",
        color: this.props.fontColor,
      };
    }

    return (
      <div className={activeState}>
        <div className="popup_sign_up_main_wrapper">
          <div
            className="popup_overlay"
            onClick={this.props.deActivatePopup}
          ></div>
          <div
            className="popup_sign_up_wrapper"
            style={{
              background: `url(${this.props.backgroundImage})`,
              backgroundSize: "contain",
              backgroundPosition: "bottom",
            }}
          >
            <div className="popup-container">
              <div className="popup_close" onClick={this.props.deActivatePopup}>
                <ImgLazyLoad
                  src={`${ContentMediaPath}images/close-grey.svg`}
                  alt="Close Pop Up"
                />
              </div>
              <div className="popup_content" style={backgroundStyle}>
                <h3
                  className="case1"
                  style={{
                    color: this.props.fontColor,
                  }}
                >
                  {this.props.title}
                </h3>
                <div
                  dangerouslySetInnerHTML={{ __html: this.props.content }}
                  style={{
                    textAlign: !!this.props.content
                      ? this.props.contentAlignment
                      : "center",
                  }}
                />
                <div className="popup_sign_form">
                  {this.props.popupCTA && (
                    <div className={emailInputContainerState}>
                      <div className="popup_input_box">
                        <input
                          className={emailInputState}
                          placeholder="Enter your email address…"
                          type="email"
                          value={this.state.emailAddress}
                          onChange={(e) => {
                            emailInput(e);
                          }}
                        />
                        <span
                          className={errorMessageState}
                          style={{
                            display: !this.state.isPopupEmailValid
                              ? "block"
                              : "none",
                          }}
                        >
                          Please provide a valid email address.
                        </span>
                      </div>

                      <div className="popup_btn_box">
                        <Button
                          type={this.props.popupCTA.format}
                          size={16}
                          buttonSize={this.props.popupCTA.size}
                          onClick={() =>
                            trySubmit(
                              this.state.emailAddress,
                              this.props.popupCTA.url
                            )
                          }
                        >
                          {this.props.popupCTA.name}
                        </Button>
                      </div>
                    </div>
                  )}
                  <a
                    href="/privacy-policy"
                    style={{ color: this.props.fontColor }}
                  >
                    Privacy Policy
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SubscribeNowPopup;
